/**
 * Redux combined reducer for project page
 * @author Kuba Siemiątkowski <kuba@crowdspring.com>
 */

import { combineReducers } from 'redux';
import ProjectPageReducer from 'project/ducks/project';
import ParticipateReducer from 'project/ducks/form';
import AwardsReducer from 'project/ducks/awards';
import FeaturesReducer from 'project/ducks/features';
import CollaboratorsReducer from 'project/ducks/collaborators';
import FocusGroupReducer from 'focus_groups/ducks';
import PresentationReducer from 'presentations/ducks';
import WrapupReducer from 'project/ducks/wrapup';
import NDAsReducer from 'project/ducks/ndas';
import CreativesReducer from 'project/ducks/creatives';
import EliteReducer from 'project/ducks/elite';

const RootReducer = combineReducers({
  projectPage: ProjectPageReducer,
  participateForm: ParticipateReducer,
  awards: AwardsReducer,
  features: FeaturesReducer,
  collaborators: CollaboratorsReducer,
  focusGroups: FocusGroupReducer,
  presentations: PresentationReducer,
  wrapup: WrapupReducer,
  ndas: NDAsReducer,
  creatives: CreativesReducer,
  elite: EliteReducer,
});

export default RootReducer;
